module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921014149_T.338f4980.jpg";